import FilterDefaultValueHelper from './filter-default-value-helper'
import { UserHelper } from '../../../../../../helpers/user-helper'

export default class DashboardCasesFiltersDefaultValueHelper extends FilterDefaultValueHelper {
    static defaultValues

    static setDefaultValues() {
        this.defaultValues = {
            dateRange: super.getDateRange(365),
            addresses: super.getDefaultAddress(),
            contactEmail: this.getEmailValue()
        }
    }

    static getEmailValue() {
        return UserHelper.isUserHasAllCasesAccess() ? null :
            UserHelper.getUserData().email
    }
}
